<template>
  <article class="tes-article tes-article_page tes-article_empty"
           itemscope itemtype="http://schema.org/Article">

    <header class="tes-article__header">

      <h1 class="tes-article__header-title">&nbsp;</h1>

    </header>

    <div class="tes-article__introduction">
      <div class="tes-article__introduction-icon-wrapper tes-article__introduction-icon-wrapper_style" >
        <StarYellowIcon class="tes-article__introduction-icon" width="40" height="38" />
      </div>
      <div class="tes-article__introduction-content">&nbsp;</div>
    </div>

    <nav class="tes-article__theses">
      <h2 class="tes-article__theses-list-header">Содержание:</h2>
      <ul class="tes-article__theses-list">
        <li class="tes-article__theses-list-item" v-for="num in [1,2,3,4,5]" v-bind:key="num">
          <span class="tes-article__thesis-link">&nbsp;</span>
        </li>
      </ul>
    </nav>

    <div class="tes-article__body">
      <p class="tes-article__paragraph" v-for="num in [1,2,3,4,5,6,7,8,9,10]" v-bind:key="num">
        <span v-for="n in Array.from({length: Math.floor(2 + Math.random() * 10)})">&nbsp;</span>
      </p>
    </div>


  </article>
</template>

<script lang="ts">
import CommentBarsIcon from '~/assets/icons/comment_bars.svg'
import EyeIcon from '~/assets/icons/eye.svg'
import Rating12PlusIcon from '~/assets/icons/age-ratings/12-plus.svg'
import StarYellowIcon from '~/assets/icons/star-yellow.svg'

export default {
  name: 'PostEmptyView',
  components: {CommentBarsIcon, EyeIcon, Rating12PlusIcon,StarYellowIcon}
}
</script>

<style scoped>

</style>
